import { AlertsCommentary } from '@aloft/toolkit-shared';

export const trimAlertCommentaryFormValue = (value: unknown): string | undefined => {
  if (typeof value !== 'string') {
    return undefined;
  }
  const trimmed = value.trim();
  return trimmed === '' ? undefined : trimmed;
};

export const finalizeAlertCommentaryValue = (
  alertsCommentary: AlertsCommentary | undefined,
  alertCommentaryKey: string,
  value: unknown,
): AlertsCommentary | undefined => {
  const currentComment = trimAlertCommentaryFormValue(value);
  const nextAlertsCommentary = { ...(alertsCommentary ?? {}) };

  if (currentComment === undefined) {
    delete nextAlertsCommentary[alertCommentaryKey];
  } else {
    nextAlertsCommentary[alertCommentaryKey] = currentComment;
  }

  return Object.keys(nextAlertsCommentary).length ? nextAlertsCommentary : undefined;
};
